export default __webpack_public_path__ + "static/media/Photo.a1f76ec6.png";